@if (!isAuthOrNewEntryRoute) {
  <header class="z-[301]">
    @if (isLoadingSignal()) {
      <p-progressBar [style]="{ width: '6px' }" class="absolute w-full" mode="indeterminate" />
    }
    <ic-file-uploader-panel />
  </header>
}

<main [ngClass]="{ 'primeng-override isla-bg': isRouteMatched() }" class="grow overflow-y-auto">
  @if (isRouteMatched()) {
    <div class="isla-wing-container pointer-events-none">
      <img
        class="isla-wing-left animate-duration-[2500ms] animate-fade-right animate-ease-out"
        src="assets/svg/isla-wing-left.svg"
        alt="Isla wing left"
      />
      <img
        class="isla-wing-right animate-duration-[2500ms] animate-fade-left animate-ease-out"
        src="assets/svg/isla-wing-right.svg"
        alt="Isla wing right"
      />
    </div>
  }

  @if (!isCookiesFeatureEnabled) {
    <p-message styleClass="block" severity="error" icon="pi pi-times-circle">{{ enableCookiesMessage }}</p-message>
  }

  <ic-shell [hideUpdateBanner]="hideRefreshBanner" class="flex-y [&]:h-full">
    <div
      class="flex h-full flex-col [&>router-outlet+*]:min-h-0 [&>router-outlet+*]:flex-1 [&>router-outlet+*]:overflow-y-auto"
    >
      <router-outlet class="main-router-outlet" />
      <ic-patient-auth-footer />
    </div>
  </ic-shell>
</main>

<p-toast [preventOpenDuplicates]="true" />
